__turbopack_context__.v({
  "button": "Button-module-scss-module__YsLvQG__button",
  "circular": "Button-module-scss-module__YsLvQG__circular",
  "colorBlack": "Button-module-scss-module__YsLvQG__colorBlack",
  "colorBlue": "Button-module-scss-module__YsLvQG__colorBlue",
  "colorWhite": "Button-module-scss-module__YsLvQG__colorWhite",
  "fullWidth": "Button-module-scss-module__YsLvQG__fullWidth",
  "ghost": "Button-module-scss-module__YsLvQG__ghost",
  "iconAfter": "Button-module-scss-module__YsLvQG__iconAfter",
  "iconBefore": "Button-module-scss-module__YsLvQG__iconBefore",
  "iconOnly": "Button-module-scss-module__YsLvQG__iconOnly",
  "label": "Button-module-scss-module__YsLvQG__label",
  "labelText": "Button-module-scss-module__YsLvQG__labelText",
  "lg": "Button-module-scss-module__YsLvQG__lg",
  "link": "Button-module-scss-module__YsLvQG__link",
  "loading": "Button-module-scss-module__YsLvQG__loading",
  "md": "Button-module-scss-module__YsLvQG__md",
  "noUppercase": "Button-module-scss-module__YsLvQG__noUppercase",
  "outline": "Button-module-scss-module__YsLvQG__outline",
  "primary": "Button-module-scss-module__YsLvQG__primary",
  "primary-outlined": "Button-module-scss-module__YsLvQG__primary-outlined",
  "secondary": "Button-module-scss-module__YsLvQG__secondary",
  "sm": "Button-module-scss-module__YsLvQG__sm",
  "spin": "Button-module-scss-module__YsLvQG__spin",
  "spinner": "Button-module-scss-module__YsLvQG__spinner",
  "spinnerIcon": "Button-module-scss-module__YsLvQG__spinnerIcon",
  "textUnderlineOnly": "Button-module-scss-module__YsLvQG__textUnderlineOnly",
  "underline": "Button-module-scss-module__YsLvQG__underline",
});
